import React from "react";
import { TextField, Box, InputLabel } from "@mui/material";
import { useTranslation } from "react-i18next";

const InputTextarea = ({
  label,
  type,
  disabled = false,
  InputProps,
  onChange,
  error,
  value,
  firstUpperCase,
  variant,
  step,
  placeholder,
  negativeAvailable,
  setValue,
  rows,
  sx,
  ...rest
}) => {
  const { t } = useTranslation();
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.stopPropagation();
    }
  };
  return (
    <Box sx={{ position: "relative" }} className="input_text">
      <InputLabel sx={[{ mb: "8px" }, sx]}>{t(label)}</InputLabel>

      <TextField
        multiline
        rows={rows ? rows : 5}
        //maxRows={10}
        onKeyDown={handleKeyDown}
        type={type === "number" ? "text" : type}
        onChange={onChange}
        variant={variant || "outlined"}
        error={!!error}
        helperText={error?.message ? t(`error_message:${error?.message}`) : ""}
        fullWidth
        value={value}
        placeholder={t(placeholder)}
        disabled={disabled}
        InputProps={InputProps ? InputProps : {}}
        sx={{
          textarea: { textAlign: "justify", lineHeight: "24px !important" },
        }}
        {...rest}
      />
    </Box>
  );
};

export default InputTextarea;
